import { Grid } from '@mui/material';
import { ScreenConfiguration } from 'src/components/screenConfiguration';
import { InputWidget } from 'src/components/widget';
import { lang, useUserRole } from 'src/utils';

import { locationDetailsHeaderProps } from './LocationGroupDetailsHeader.interface';
import { SubHeader, SubHeaderText } from './LocationGroupDetailsHeader.styled';

export const LocationGroupDetailsHeader = (
  props: locationDetailsHeaderProps,
) => {
  const { isViewOnly } = useUserRole();

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12} md={3}>
          <InputWidget
            label={lang.locationGroupName}
            disabled={isViewOnly}
            onChange={(value) => props.onHandleChange(value as string)}
            value={props.locationGroupName}
            hasError={!props.locationGroupName}
            error={!props.locationGroupName ? `${lang.inputFieldError}` : ''}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <SubHeader>{props.locationGroupData?.channel_name}</SubHeader>
          {!props.isLoadingLayouts && props.layoutTypes && (
            <SubHeaderText>
              {
                props.layoutTypes.find(
                  (layout) =>
                    layout.id === props.locationGroupData?.layout_type_id,
                )?.name
              }
            </SubHeaderText>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <SubHeader>{lang.screenConfiguration}</SubHeader>
          {props.locationGroupData?.channel_name && (
            <ScreenConfiguration
              channelName={props.locationGroupData?.channel_name}
              scale={0.05}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};
